import { createContext, useContext, useState, useEffect } from "react";
import { getAllEndcustomerArticles } from "API/swesum";
import { getEndCustomerArticles as APIMySiteGetEndCustomerArticles } from "API/myPages";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { useAuth } from "Hooks/useAuth";

const ArticlesContext = createContext(null);

export const ArticlesContextProvider = ({ children }) => {
  const { isAdmin } = useAuth();
  const [endCustomerArticleMap, setEndCustomerArticleMap] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const { openError } = usePopupNotificationContext();

  const fetchEndCustomerArticles = async () => {
    if (endCustomerArticleMap !== null) return;
    setLoading(true);
    try {
      const endcustomerRes = isAdmin
        ? await getAllEndcustomerArticles()
        : await APIMySiteGetEndCustomerArticles();
      setEndCustomerArticleMap(
        endcustomerRes.reduce((map, article) => {
          map[article.Id] = { Name: article.Name, Payrule: article.Payrule };
          return map;
        }, {})
      );
      setReady(true);
    } catch (err) {
      openError("Något gick fel vid hämtning av slutkundsartiklar");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEndCustomerArticles();
  }, []);

  return (
    <ArticlesContext.Provider
      value={{
        endCustomerArticleMap,
        fetchEndCustomerArticles,
        ready,
        loading,
      }}
    >
      {children}
    </ArticlesContext.Provider>
  );
};

export const useArticles = () => useContext(ArticlesContext);
